import React from "react";
import Paper from '@material-ui/core/Paper';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import MetricSwitch from './MetricSwitch';
import MetricPreferenceModal from './MetricPreferenceModal';
import { GetMetricValue } from './util';

import styled from "styled-components";

const SelectedMetricsWrapper = styled.div`
  position:relative;
`
const DoubleDivider = styled(Divider)`
  height:2px;
`
const FadedTile = styled(GridListTile)`
  opacity:0.5;
`
const TileContent = styled.div`
  text-align: center;
`
const TileContentContainer = styled.div`
  display:flex;
  flex-flow: column;
  align-items:center;
  justify-content:center;
  text-align:center;

  & div:first-child {
    color:#333;
  }
  & div:nth-child(2) {
    color:#AAA;
  }
`
class MetricTile extends React.Component {
  state = {
    isExpanded: false
  };
  setGridListTile = tile => {
    const { fadeOutMetrics } = this.state;
    const { metricData } = this.props;
    if (tile.isSelected) {
      return (
        <GridListTile key={tile.screenElementId} className="headerDashboard_Title">
          <TileContentContainer>
            <TileContent id={`metricTile${tile.title.toUpperCase()}`} className="banner-metric">{GetMetricValue(metricData, tile.screenElementId)}</TileContent>
            <div>{tile.title.toUpperCase()}</div>
          </TileContentContainer>
        </GridListTile>
      )
    } else if (fadeOutMetrics) {
      return (
        <FadedTile key={tile.screenElementId} className="headerDashboard_Title">
          <TileContentContainer>
            <TileContent id={`metricTile${tile.title.toUpperCase()}`} className="banner-metric">{GetMetricValue(metricData, tile.screenElementId)}</TileContent>
            <div>{tile.title.toUpperCase()}</div>
          </TileContentContainer>
        </FadedTile>
      )
    } else {
      return (
        <GridListTile key={tile.screenElementId} className="headerDashboard_Title">
          <TileContentContainer>
            <TileContent id={`metricTile${tile.title.toUpperCase()}`} className="banner-metric">{GetMetricValue(metricData, tile.screenElementId)}</TileContent>
            <div>{tile.title.toUpperCase()}</div>
          </TileContentContainer>
        </GridListTile>
      )
    }
  };

  renderSelectedMetrics = (selectedTiles) => {
    const { isExpanded } = this.state;
    const { tileData } = this.props;
    return (
      <SelectedMetricsWrapper>
        {this.renderModalEditButton(isExpanded, tileData)}
        <GridList
          className="headerDashboard_List"
          cellHeight={90}
          cols={6}
          spacing={1}>
          {this.setGridList(selectedTiles)}
        </GridList>
      </SelectedMetricsWrapper>);
  }

  handleClose = () => {
    this.setState({ isExpanded: false });
  }
  onEditButtonHover = () => {
    this.setState({
      fadeOutMetrics: true
    })
  }

  onEditButtonLeave = () => {
    this.setState({
      fadeOutMetrics: false
    })
  }

  sortByTitleAlphabetically = (a, b) => {
    if (a.title < b.title) { return -1; }
    if (a.title > b.title) { return 1; }
    return 0;
  }

  renderModalEditButton = (isExpanded, tileData) => {
    return (
      <MetricPreferenceModal
        onEditButtonHover={this.onEditButtonHover}
        onEditButtonLeave={this.onEditButtonLeave}
        screenType={this.props.screenType}
        onClose={this.handleClose}
        isExpanded={isExpanded}
        tileData={tileData}
        updateContactScreenPreferencesCallback={this.props.updateContactScreenPreferencesCallback} />);
  }

  handleChange = () => {
    this.setState(state => ({ isExpanded: !state.isExpanded }));
  };

  setGridList = tiles =>
    tiles &&
    tiles
      .sort((a, b) => a.layoutOrder - b.layoutOrder)
      .map(tile => {
        return this.setGridListTile(tile);
      });

  render() {
    const { isExpanded } = this.state;
    const { tileData, guestPermissions } = this.props;
    if (!tileData) return null;

    const selectedTiles = tileData.filter(x => x.isSelected);
    const unselectedTiles = tileData.filter(x => !x.isSelected).sort(this.sortByTitleAlphabetically);
    if (guestPermissions && guestPermissions.isGuest && !guestPermissions.hasRestrictedMetricPermission && !guestPermissions.hasFullMetricPermission) return null;

    return (
      <React.Fragment>
        {this.renderSelectedMetrics(selectedTiles)}
        <Collapse in={isExpanded}>
          <Paper elevation={4}>
            <GridList
              className="headerDashboard_List"
              cellHeight={90}
              cols={6}
              spacing={1}>
              {this.setGridList(unselectedTiles)}
            </GridList>
          </Paper>
        </Collapse>
        <DoubleDivider />
        <Grid
          container
          direction="row"
          justify="flex-end">
          <MetricSwitch
            onChange={this.handleChange}
            isExpanded={isExpanded}>
          </MetricSwitch>
        </Grid>
      </React.Fragment>
    );
  }
}

export default MetricTile;
